import { render, staticRenderFns } from "./NumberOfFeedbackRecieved.vue?vue&type=template&id=3df0d7cd&"
import script from "./NumberOfFeedbackRecieved.vue?vue&type=script&lang=js&"
export * from "./NumberOfFeedbackRecieved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports